export const product = [
  {
    id: '1',
    product_name: 'Chlorine Granular',
    country: 'RRC',
    type: 'Granul',
    package: 'Kg / Pail',
    img: 'img/product-1.jpg',
    category: 'chemical',
    description: 'Disinfektan utama kolam renang. Membunuh bakteri, virus, dan alga secara efektif. TCCA 90%, cocok untuk semua jenis kolam.',
  },
  {
    id: '2',
    product_name: 'Chlorine Tablet',
    country: 'RRC',
    type: 'Tablet',
    package: 'Kg / Pail',
    img: 'img/product-2.jpg',
    category: 'chemical',
    description: 'Klorin tablet slow-release untuk kolam renang. Mudah digunakan dengan feeder otomatis, cocok untuk perawatan harian.',
  },
  {
    id: '3',
    product_name: 'Liquid HCL',
    country: 'Chiwi Chemical',
    type: 'Liquid',
    package: 'Jerry Can',
    img: 'img/product-3.jpg',
    category: 'chemical',
    description: 'HCl cair untuk menurunkan pH dan membersihkan dinding kolam dari kerak mineral. Kemasan jerry can aman dan mudah dituang.',
  },
  {
    id: '4',
    product_name: 'Tawas Kristal',
    country: 'Japan',
    type: 'Crystal',
    package: 'Kg',
    img: 'img/product-4.jpg',
    category: 'chemical',
    description: 'Flocculant alami untuk menjernihkan air kolam keruh. Menggumpalkan partikel halus agar mudah disedot filter.',
  },
  {
    id: '5',
    product_name: 'Sodium Hypo',
    country: 'Chiwi Chemical',
    type: 'Liquid',
    package: 'Jerry Can',
    img: 'img/product-5.jpg',
    category: 'chemical',
    description: 'Sodium hipoklorit cair untuk desinfeksi dan pemutihan kolam renang. Efektif mengatasi air hijau dan alga.',
  },
  {
    id: '6',
    product_name: 'PAC Powder',
    country: 'Germany',
    type: 'Powder',
    package: '5 Ltr',
    img: 'img/product-6.jpg',
    category: 'chemical',
    description: 'Poly Aluminium Chloride untuk koagulasi dan penjernihan air kolam secara cepat. Kualitas premium dari Jerman.',
  },
  {
    id: '7',
    product_name: 'Terusi',
    country: 'Japan',
    type: 'Crystal',
    package: 'Zack / Kg',
    img: 'img/product-7.jpg',
    category: 'chemical',
    description: 'Copper sulfate untuk mencegah dan membasmi pertumbuhan alga di dinding dan lantai kolam renang.',
  },
  {
    id: '8',
    product_name: 'Caustic Soda',
    country: 'RRC',
    type: 'Crystal',
    package: 'Zack / Kg',
    img: 'img/product-8.jpg',
    category: 'chemical',
    description: 'Sodium hidroksida untuk menaikkan pH dan alkalinitas air kolam renang dengan cepat dan efektif.',
  },
  {
    id: '9',
    product_name: 'Soda Ash',
    country: 'Japan',
    type: 'Powder',
    package: 'Kg',
    img: 'img/product-9.jpg',
    category: 'chemical',
    description: 'Sodium karbonat untuk meningkatkan pH air kolam secara perlahan. Lebih aman dan mudah dikontrol dibanding caustic soda.',
  },
  {
    id: '10',
    product_name: 'Tawas Powder',
    country: 'Japan',
    type: 'Powder',
    package: 'Kg',
    img: 'img/product-10.jpg',
    category: 'chemical',
    description: 'Tawas dalam bentuk serbuk untuk penjernihan air kolam keruh. Mudah larut dan bekerja cepat dalam waktu 24 jam.',
  },
  {
    id: '11',
    product_name: 'Salt Industrial',
    country: 'Indonesia',
    type: 'Crystal',
    package: 'Zack',
    img: 'img/product-11.jpg',
    category: 'filter-media',
    description: 'Garam industri untuk sistem klorinator garam (salt chlorinator). Menghasilkan klorin alami dari air garam secara otomatis.',
  },
  {
    id: '12',
    product_name: 'Silica Sand',
    country: 'Indonesia',
    type: 'Granul',
    package: 'Zack',
    img: 'img/product-12.jpg',
    category: 'filter-media',
    description: 'Pasir silika sebagai media filter sand filter kolam renang. Efektif menyaring partikel 20–100 mikron dari air kolam.',
  },
  {
    id: '13',
    product_name: 'Kaporit',
    country: '-',
    type: 'Powder',
    package: 'Zack / Pail',
    img: 'img/product-13.jpg',
    category: 'chemical',
    description: 'Kalsium hipoklorit (kaporit) untuk desinfeksi dan shock treatment kolam renang. Tersedia dalam kemasan sak dan pail.',
  },
  {
    id: '14',
    product_name: 'Ball Valve Astral',
    country: 'Astral',
    type: 'Valve',
    package: 'Pcs',
    img: 'img/product-14.jpg',
    category: 'accessories',
    description: 'Ball valve merk Astral untuk instalasi sistem perpipaan kolam renang. Durable, tahan korosi, berbagai ukuran tersedia.',
  },
  {
    id: '15',
    product_name: 'Check Valve Astral',
    country: 'Astral',
    type: 'Valve',
    package: 'Pcs',
    img: 'img/product-15.jpg',
    category: 'accessories',
    description: 'Check valve Astral mencegah air mengalir balik ke pompa. Penting untuk sistem sirkulasi kolam renang yang optimal.',
  },
  {
    id: '16',
    product_name: 'Inlet & Vacuum Fitting',
    country: '-',
    type: 'Fitting',
    package: 'Pcs',
    img: 'img/product-16.jpg',
    category: 'accessories',
    description: 'Fitting inlet dan vacuum untuk instalasi nosel balik dan port vacuum di dinding kolam renang.',
  },
  {
    id: '17',
    product_name: 'Pool Brush',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-17.jpg',
    category: 'accessories',
    description: 'Sikat kolam renang untuk membersihkan dinding dan lantai pool dari alga dan kotoran. Bulu nilon kuat dan tahan lama.',
  },
  {
    id: '18',
    product_name: 'Algae Brush',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-18.jpg',
    category: 'accessories',
    description: 'Sikat khusus alga dengan bulu kawat stainless untuk membersihkan alga membandel pada plester dan keramik kolam.',
  },
  {
    id: '19',
    product_name: 'Leaf Skimmer',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-19.jpg',
    category: 'accessories',
    description: 'Jaring skimmer untuk mengangkat daun, serangga, dan kotoran permukaan air kolam renang secara cepat dan mudah.',
  },
  {
    id: '20',
    product_name: 'Vacuum Head 8 Wheels',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-20.jpg',
    category: 'accessories',
    description: 'Kepala vacuum 8 roda untuk menyedot kotoran dan pasir dari lantai kolam renang. Bergerak mulus di semua permukaan.',
  },
  {
    id: '21',
    product_name: 'Vacuum Hose 9 Meter',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-21.jpg',
    category: 'accessories',
    description: 'Selang vacuum 9 meter untuk menyedot lantai kolam. Fleksibel, tidak mudah tersumbat, cocok untuk kolam ukuran medium–large.',
  },
  {
    id: '22',
    product_name: 'Telescopic Handle 16',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-22.jpg',
    category: 'accessories',
    description: 'Gagang teleskopik 16 feet yang dapat disesuaikan panjangnya untuk vacuum head, sikat, dan leaf skimmer.',
  },
  {
    id: '23',
    product_name: 'Test Kit Liquid',
    country: '-',
    type: 'Test Kit',
    package: 'Pcs',
    img: 'img/product-23.jpg',
    category: 'accessories',
    description: 'Test kit reagen cair untuk mengukur pH dan klorin bebas air kolam renang. Akurat, mudah digunakan, hasil instan.',
  },
  {
    id: '24',
    product_name: 'Test Kit Set',
    country: '-',
    type: 'Test Kit',
    package: 'Set',
    img: 'img/product-24.jpg',
    category: 'accessories',
    description: 'Set lengkap test kit kolam renang: pH, klorin, alkalinitas, dan kesadahan. Ideal untuk pengecekan kualitas air rutin.',
  },
  {
    id: '25',
    product_name: 'Stick Vacuum',
    country: '-',
    type: 'Cleaning Tool',
    package: 'Pcs',
    img: 'img/product-25.jpg',
    category: 'accessories',
    description: 'Stick vacuum portable untuk membersihkan kotoran dasar kolam tanpa perlu selang panjang. Praktis untuk kolam kecil.',
  },
];
